export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/general-highlights.34cddc0b.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};